module.exports = __webpack_public_path__ + "img/08.6142d696.jpg";